import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useJob } from '../components/JobProvider'
import FileUploader from '../components/FileUploader';
import UploadedFileView from '../components/UploadedFileView';
import ModalMaterialsWelcome from '../components/ModalMaterialsWelcome';
import styles from './Upload.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';


export default function SpycareUpload() {
    const [uploadData, setUploadData] = useState([]);
    const { search } = useLocation();
    const [clientName, setClientName] = useState(null);
    const { spycareJobId: spycareJob } = useJob()
    const [spycareJobObject, setSpycareJobObject] = useState();

    const token = '5dc2161a-b9e3-49fe-809a-d8d01c831fff';

    const queryString = (React.useMemo(() => new URLSearchParams(search), [search])).get("h");

    const handleFileUploaderCallback = (data) => {
        const formData = new FormData();
		formData.append("jobId", spycareJobObject.spycareJobId);
		for(let i = 0; i < data.length; i++){
			formData.append("files[" + i + "]", data[i]);
			formData.append("documentNames[" + i + "]", data[i].name);
		}

        fetch(`${process.env.REACT_APP_API_URL}/data/spycare/multipart_document`, {
            body: formData,
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => res.json())
        .then(docs => {
            const uploadedDocs = [];
            docs.map(d => uploadedDocs.push({id: d.spycareDocumentId, name: d.fileName, size: d.size, url: d.url}));
            setUploadData(uploadedDocs);
        },
        (error) => {
            console.log(error);
        });
    }

    const handleFileViewCallback = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}/data/spycare/document/${id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json)
        .then(() => {
            setUploadData(uploadData.filter(file => file.id !== id));
        })
    }

    // Pull the job data from the hash provided in the query string or use the currently logged in user's job id
    useEffect(() => {
        if (queryString) {
            fetch(`${process.env.REACT_APP_API_URL}/data/spycare/audit_material/${queryString}`, {
                headers: {
                         Authorization: `Bearer ${token}`
                     }
            })
            .then(res => res.json())
            .then(
                (result) => {
                setClientName(result.job.client?.clientName);
                setSpycareJobObject(result.job);
            },
                (error) => {
                    console.log(error);
                }
            )
        } else if (spycareJob) {
            fetch(`${process.env.REACT_APP_API_URL}/data/spycare_job/id/${spycareJob}` , {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setClientName(result.job.client?.clientName);
                    setSpycareJobObject(result)
                }
            )
        }
    }, [queryString, spycareJob]);

    return (
        <>
        <ModalMaterialsWelcome companyName={clientName}/>
            <Container className="mt-3">
                <Row>
                    <Col xs={12} className="d-flex justify-content-between align-content-center">
                        <h1 className="mb-0">SpyGlass Materials Upload</h1>
                    </Col>
                </Row>
            </Container>
            <Container className="mt-3 mb-3">
                <Row>
                    <Col xs={12} lg={3} className="mt-lg-0">
                        <Card className="card-h-100">
                            <Card.Body>
                            <div className="cardTitleContainer">
                                <Card.Title className="d-flex align-items-center">
                                    <div className="circleNumber me-2 bg-primary color-white">1</div> Select Your Files
                                </Card.Title>
                            </div>
                            <Card.Text>
                            Drag and Drop your files into the blue box below or alternatively,
                        click the white “Choose Files” button to select the files you want to attach.
                        Select more than one file by holding Shift or Ctrl as you select. Once your selection is made, click Open.
                            </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <Card className="card-h-100">
                            <Card.Body>
                                <div className="cardTitleContainer">
                                    <Card.Title className="d-flex align-items-center">
                                        <div className="circleNumber me-2 bg-primary color-white">2</div>
                                        <span className="ls-n3">Review Your Selected Files</span>
                                    </Card.Title>
                                </div>
                                <Card.Text>
                                    The files to be uploaded will be displayed below. Review for accuracy.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <Card className="card-h-100">
                            <Card.Body>
                                <div className="cardTitleContainer">
                                    <Card.Title className="d-flex align-items-center">
                                        <div className="circleNumber me-2 bg-primary color-white">3</div>
                                        Upload Your Files
                                    </Card.Title>
                                </div>
                                <Card.Text>
                                    Select the blue “Upload” button to submit the files to SpyGlass.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <Card className="card-h-100">
                            <Card.Body>
                                <div className="cardTitleContainer">
                                    <Card.Title className="d-flex align-items-center">
                                        <div className="circleNumber me-2 bg-primary color-white">4</div>
                                        Confirm Your Uploads
                                    </Card.Title>
                                </div>
                                <Card.Text>
                                    Wait for the upload progress bar to complete and the confirmation message to display.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <div className="cardTitleContainer">
                                    <Card.Title>File Upload</Card.Title>
                                </div>
                                <Card.Text>
                                    <span className="color-warning pe-1"><FontAwesomeIcon icon="exclamation-circle" /></span>The total size of the files must be less than 1 GB for each attempt. You can upload more than 1 GB with multiple attempts
                                </Card.Text>
                                <FileUploader callback={handleFileUploaderCallback} />
                                    {uploadData.length > 0
                                    ? <>
                                        <h3>Uploaded Successfully</h3>
                                        <div className={styles.uploadedFileContainer}>
                                            {uploadData.map((file, index) => <UploadedFileView callback={handleFileViewCallback} file={file} key={index} />
                                            )}
                                        </div>
                                    </>
                                    : <></>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}